import { useTranslations } from 'next-intl';

import { AppleStoreIconSVG } from '@/icons/AppleStoreIconSVG';
import { GooglePlayIconSVG } from '@/icons/GooglePlayIconSVG';

import styles from '@/contexts/VerificationContext/VerificationModal/VerificationBanner.module.scss';

export const VerificationBanner = () => {
  const t = useTranslations('footer');
  return (
    <div className={styles.verificationBanner}>
      <section className={styles.content}>
        <div className={styles.apps}>
          <a
            target="_blank"
            href={process.env.NEXT_PUBLIC_CINERAMA_APP_APP_STORE_URL}
            className={styles.app}
          >
            <AppleStoreIconSVG />

            <div>
              <p className={styles.appText}>{t('apps.downloadFrom')}</p>
              <p className={styles.appTitle}>Apple Store</p>
            </div>
          </a>
          <a
            target="_blank"
            href={process.env.NEXT_PUBLIC_CINERAMA_APP_GOOGLE_PLAY_URL}
            className={styles.app}
          >
            <GooglePlayIconSVG />
            <div>
              <p className={styles.appText}>{t('apps.downloadFrom')}</p>
              <p className={styles.appTitle}>Google Play</p>
            </div>
          </a>
        </div>
        <h1 className={styles.title}>{t('apps.downloadApp')}</h1>
        <p className={styles.subtitle}>{t('apps.watchMoviesFromPhone')}</p>
      </section>
    </div>
  );
};
